const nullToken = 'null'

export default {
  id : 'Expression.FieldParser.ConstantNullField',
  type : 'nullField',
  sort : -8,
  handles : ( field, context ) => {
    return field.type === 'ExpressionParser.Field' && field.value?.trim() === nullToken
  },
  parse : async ( field, context ) => {
    // no need to null the field.value?.trim again, the handles did it for us
    const toReturn = {
      type : 'ExpressionField.null',
      value : null,
    }
    if ( context?.includeAstInfo ) {
      toReturn.absoluteLocation = {
        startIndex : field.startIndex,
        endIndex : field.endIndex,
      }
      toReturn.relativeLocation = {
        startIndex : 0,
        endIndex : field.untrimmed?.length
      }
      toReturn.untrimmed = field.untrimmed
    }
    return toReturn
  }
}
